import { StyleSheet } from 'aphrodite';

export const housecallProColor = '#0C7FF2';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: housecallProColor,
		marginTop: 20,
		border: `1px solid ${housecallProColor}`,
	},
	integrationTitle: {
		color: housecallProColor,
	},
	graphic: {
		display: 'block',
		maxWidth: 200,
		marginBottom: 16,
	},
	integrationGraphic: {
		display: 'block',
		':nth-child(1n) > svg': {
			height: 'auto',
			width: 180,
		},
	},
});
